import { render, staticRenderFns } from "./EnterPhoneNumber.vue?vue&type=template&id=7c6705fb&scoped=true&"
import script from "./EnterPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./EnterPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./EnterPhoneNumber.vue?vue&type=style&index=0&id=7c6705fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6705fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
